// extracted by mini-css-extract-plugin
export default {"text":"Submit_text__Ramaa"};